import { amendTradeSelectorsFactory } from 'state/secondaryMarket/shared/amend/amend.selector';

export const limitOrderAmendSelectors = amendTradeSelectorsFactory('limitOrder');
